module.exports = __webpack_public_path__ + "static/source-code-98db2049945279114c5bf5efa1b67573.png";